// import { Badge } from "react-bootstrap";
// import BadgeEstados from "../../components/BadgeEstado";
// import AccionesActaTable from "../../views/Acciones/AccionesActaTable";
// import HeaderColumn from "./components/HeaderColumn";

import { Badge } from "react-bootstrap";
import BadgeEstado from "../../../components/BadgeEstado";
import BadgeEstadoActa from "../../../components/BadgeEstadoActa";
import { handlerGetActa } from "../../../handlers/actas.handler";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { usePodadoresStore } from "../../../store/podadoresStore";
import StarDisplay from "../../../components/StarDisplay";
//!REVISAR
// import "./style.css";

export const tableDataPodadores = (data, width /* setPodadoresSelect, */ /* podadoresSelect */) => {
  const { setPodadoresSelect, podadoresSelect } = usePodadoresStore.getState();

  const columns = [
    // { field: "id", headerName: "ID", hide: true },
    // {
    //   field: "actions",
    //   headerName: "Ver",
    //   minWidth: 50,
    //   flex: 0.1,
    //   sortable: false,
    //   headerClassName: "headerActions",
    //   renderCell: (params) => {
    //     return (
    //       <div className="d-flex gap-2 align-items-center">
    //         <RemoveRedEyeIcon
    //           onClick={() => handlerGetActa(params.row.id)}
    //           sx={{ color: "#1134C9" }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      field: "seleccionar",
      headerName: "",
      align: "center",
      minWidth: 20,
      flex: 0.1,
      sortable: false,
      // align:"center",

      headerClassName: "headerActions",
      renderCell: (params) => {
        return (
          <div className="d-flex gap-2 align-items-center">
            <input
              className="form-check-input"
              type="checkbox"
              checked={podadoresSelect.some((podador) => podador.id == params.row.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setPodadoresSelect([...podadoresSelect, params.row]);
                } else {
                  setPodadoresSelect(
                    podadoresSelect.filter((podador) => {
                      return podador.id != params.row.id;
                    })
                  );
                }
              }}
            />
          </div>
        );
      },
    },
    {
      field: "nombre",
      headerName: "Nombre",
      headerClassName: "custom-header",
      minWidth: width >= 640 ? 150 : 100,
      flex: 1,
      sortable: false,
    },
    {
      //   field: "nombre",
      headerName: "Puntuación",
      headerClassName: "custom-header",
      minWidth: width <= 360 ? 110 : 150,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <p className="d-flex gap-1 align-items-end m-0">
            <StarDisplay rating={params?.row?.promedio} />
            <span
              style={{ fontSize: "12px", lineHeight: "16px" }}
            >{`(${params?.row?.cant}) `}</span>
          </p>
        );
      },
    },
    {
      field: "telefono",
      headerName: "Telefono",
      minWidth: 100,
      flex: 0.4,
      sortable: false,
      renderCell: (params) => {
        return (
          <p className="m-0">
            <span className={`${!params?.row?.telefono && "text-danger"}`}>
              {params?.row?.telefono ?? "No tiene"}
            </span>
          </p>
        );
      },
    },
    // ...(width >= 576
    //   ? [
    //       {
    //         field: "dni",
    //         headerName: "Documento",
    //         headerClassName: "custom-header",
    //         minWidth: 50,
    //         flex: 0.3,
    //         sortable: false,
    //       },
    //     ]
    //   : []),
    // ...(width >= 576
    //   ? [
    //       {
    //         field: "info",
    //         headerName: "Info",
    //         minWidth: 150,
    //         flex: 1,
    //         sortable: false,
    //         renderCell: (params) => {
    //           return (
    //             <span className={`${!params?.row?.info && "text-danger"}`}>
    //               {params?.row?.info ?? "No tiene"}
    //             </span>
    //           );
    //         },
    //       },
    //     ]
    //   : []),
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id: d?.id,
        nombre: d?.nombre,
        dni: d?.dni,
        telefono: d?.telefono,
        estado: d?.estado?.estado,
        info: d?.info,
        cant: d?.cant_puntuacion,
        promedio: d?.promedio,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.nombre)?.toString().toLowerCase().includes(value) ||
      String(d.telefono)?.toString().toLowerCase().includes(value) ||
      (width >= 576 && String(d.dni)?.toString().toLowerCase().includes(value)) ||
      (width >= 576 && String(d.info)?.toString().toLowerCase().includes(value))
    );
  };

  return { columns, rows, filter };
};
